/* eslint-disable no-param-reassign */
import { useEffect } from 'react';

const useLangSelect = (
  showRawHtml,
  setShowRawHtml,
  htmlEditorInstance,
  textAreaInstance,
  saveData,
  setSaveData,
  lang,
  onLangChange,
  fireSaveHandlerRef
) => {
  const getTextVal = () => textAreaInstance.current.option('text');

  const getHtmlVal = () => htmlEditorInstance.current.option('value');

  const setHtmlVal = (val) => htmlEditorInstance.current.option('value', val);

  const handleRawState = () => {
    if (showRawHtml) {
      const textAreaValue = getTextVal();

      setHtmlVal(textAreaValue);
      setShowRawHtml(false);
    }
  };

  const onLangSelectChanged = (e, saveAfter = false) => {
    handleRawState();

    onLangChange(e, getHtmlVal, setHtmlVal, saveAfter);
  };

  const fireSaveHandler = () => {
    handleRawState();

    onLangChange(
      { value: lang, previousValue: lang },
      getHtmlVal,
      setHtmlVal,
      false,
      true
    );
  };

  useEffect(() => {
    if (!fireSaveHandlerRef) {
      return;
    }

    fireSaveHandlerRef.current = fireSaveHandler;
  });

  useEffect(() => {
    if (saveData) {
      onLangSelectChanged({ value: lang, previousValue: lang }, true);

      setSaveData(false);
    }
  }, [saveData]);

  return [
    onLangSelectChanged,
    getTextVal,
    getHtmlVal,
    setHtmlVal,
    handleRawState
  ];
};

export default useLangSelect;
